"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthLayout = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var AuthLayout = function (props) {
    var children = props.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8 items-center bg-secondary", children: children }));
};
exports.AuthLayout = AuthLayout;
